/* eslint react/no-render-return-value: 0 */

import { IntlProvider } from 'react-intl';
import ReactDOM from 'react-dom';
import React from 'react';

/**
 * Render a modal in the page through a temporary placeholder.
 *
 * @param {React.ReactElement} modal UXCore2 Modal.
 * @param {String} market Locale.
 * @param {Object} messages Internationalization data.
 * @param {Function} done Optional completion callback.
 * @returns {ReactDOM} Instance of internationalized modal.
 * @api public
 */
export function render(modal, market, messages, done = () => {}) {
  const placeholder = document.createElement('div');
  document.body.appendChild(placeholder);

  return ReactDOM.render(
    <IntlProvider locale={ market } messages={ messages }>
      { React.cloneElement(modal, { messages }) }
    </IntlProvider>,
    placeholder,
    done
  );
}
